import React from 'react';
import { MIGRATION_SOURCES } from '../constants';

export default function SourceSelectStep({ selected, onSelect }) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Select Email Provider</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Choose the source email provider you want to migrate from
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {MIGRATION_SOURCES.map(source => (
          <button
            key={source.id}
            onClick={() => onSelect(source)}
            className={`flex items-start gap-4 p-4 rounded-xl border-2 transition-all text-left hover:shadow-md ${
              selected?.id === source.id
                ? 'border-orange-500 bg-orange-50 dark:bg-orange-900/20 shadow-md'
                : 'border-gray-200 dark:border-gray-700 hover:border-orange-300 dark:hover:border-orange-700'
            }`}
          >
            <div className="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 overflow-hidden">
              {source.icon ? (
                <img
                  src={source.icon}
                  alt={source.name}
                  className="w-7 h-7 object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <span className="text-lg font-bold text-gray-400" style={{ display: source.icon ? 'none' : 'flex' }}>
                {source.name[0]}
              </span>
            </div>
            <div className="min-w-0">
              <h4 className="font-medium text-gray-900 dark:text-white">{source.name}</h4>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{source.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
